export default {
  round: {
    type: Boolean,
    default: true
  },
  maskStyle: Object,
  duration: {
    type: [Number, String],
    default: 300
  },
  // prevent body scroll
  lockScroll: {
    type: Boolean,
    default: true
  },
  closeOnClickMask: {
    type: Boolean,
    default: true
  },
  value: Boolean,
  lazyRender: {
    type: Boolean,
    default: true
  }
}
